module.exports = __webpack_public_path__ + "img/hrc-resources.9587bc61.jpg";